class CartVariantUpdate extends HTMLSelectElement {
	constructor() {
		super();
		this.key = this.getAttribute('key');
		this.quantity = parseInt(this.getAttribute('quantity'));
		this.cartContainer = this.closest('[data-tab="mini-bag"]');

		this.addNewVariant = this.addNewVariant.bind(this);
		this.removeCurrentVariant = this.removeCurrentVariant.bind(this);
		this.addEventListener('change', (evt) =>
			this.updateLineItemVariants(evt.target.value),
		);
	}

	async updateLineItemVariants(variantId) {
		this.cartContainer.classList.add('is-loading')
		await this.removeCurrentVariant();
		await this.addNewVariant(variantId);
		await this.refreshCartDrawer(variantId);
		this.cartContainer.classList.remove('is-loading')
	}

	async addNewVariant(variantId) {
		const lineItemData = {
			id: variantId,
			quantity: this.quantity,
		};

		const fetchUrl = `${window.routes.cartAddUrl}`;

		try {
			const response = await fetch(`${fetchUrl}.js`, {
				method: 'POST',
				body: JSON.stringify(lineItemData),
				headers: { 'Content-Type': 'application/json' },
			});
			const result = await response.json();
			console.log(result);
		} catch (error) {
			console.error(error);
		}
	}

	async removeCurrentVariant() {
		const lineItemData = {
			id: this.key,
			quantity: 0,
		};

		const fetchUrl = `${window.routes.cartChangeUrl}.js`;

		try {
			const response = await fetch(fetchUrl, {
				method: 'POST',
				body: JSON.stringify(lineItemData),
				headers: { 'Content-Type': 'application/json' },
			});
			const result = await response.json();
			return result;
		} catch (error) {
			console.error(error);
		}
	}

	async refreshCartDrawer(variantId) {
		const fetchUrl = `${window.routes.rootUrl}cart?view=alt`
		const cartRefreshEvent = new CustomEvent('cartDrawer:refreshed');

		try {
			const response = await fetch(fetchUrl)
			const result = await response.text();
			this.cartContainer.innerHTML = result

			document.dispatchEvent(cartRefreshEvent)

			const cartItem = document.querySelector(`.js-cart-item[data-variant-id="${variantId}"]`)
			const rect = cartItem.getBoundingClientRect();

			const element = document.querySelector('.mini-bag__top');
			element.scrollTo({
				top: rect.top,
				behavior: 'smooth'
			});

			return;
		} catch (error) {
			throw new Error('Error:', error)
		}

	}
}

if (!customElements.get('cart-variant-selector')) {
	customElements.define('cart-variant-selector', CartVariantUpdate, {
		extends: 'select',
	});
}
